<template>
    <div class="formTitle">
      <div>{{ title }}</div>  
      <div>{{ stepTitle }}</div>  
    </div>
</template>

<script>
    export default {
        props: {
            title: {
            type: String,
            default: '學生資料 Student Particulars'
            },
            stepTitle: {
            type: String,
            default: ''
            },
        }
    }
</script>

<style lang="scss" scoped>
.formTitle{
    background-color: #3A91DD;
    font-weight: bold;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}
</style>